import { NgModule } from '@angular/core';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faArrowRight,
  faArrowRightArrowLeft,
  faBoxArchive,
  faBoxOpen,
  faBuilding,
  faBullhorn,
  faCalendarAlt,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleExclamation,
  faCircleHalfStroke,
  faClone,
  faComment,
  faCopy,
  faCrop,
  faEarthAmericas,
  faEraser,
  faFile,
  faFilePdf,
  faHome,
  faIdCardClip,
  faInfoCircle,
  faLifeRing,
  faMagnifyingGlass,
  faMagnifyingGlassPlus,
  faObjectGroup,
  faPencil,
  faPenRuler,
  faPlus,
  faQuestionCircle,
  faReceipt,
  faRefresh,
  faRotateLeft,
  faRuler,
  faRulerCombined,
  faScrewdriverWrench,
  faSitemap,
  faSort,
  faSortDown,
  faSortUp,
  faSquare,
  faStethoscope,
  faTimes,
  faToolbox,
  faTrash,
  faUpDownLeftRight,
  faUser,
  faUserPlus,
  faUserShield,
  faUserSlash,
} from '@fortawesome/free-solid-svg-icons';

@NgModule({
  declarations: [],
  imports: [FontAwesomeModule],
  exports: [FontAwesomeModule],
})
export class IconModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faArrowRight,
      faArrowRightArrowLeft,
      faBoxArchive,
      faBoxOpen,
      faBuilding,
      faBullhorn,
      faCalendarAlt,
      faCheck,
      faChevronDown,
      faChevronLeft,
      faChevronRight,
      faChevronUp,
      faCircle,
      faCircleCheck,
      faCircleExclamation,
      faClone,
      faComment,
      faCopy,
      faCircleHalfStroke,
      faCrop,
      faEarthAmericas,
      faEraser,
      faFile,
      faFilePdf,
      faHome,
      faIdCardClip,
      faInfoCircle,
      faLifeRing,
      faMagnifyingGlass,
      faMagnifyingGlassPlus,
      faObjectGroup,
      faPencil,
      faPenRuler,
      faPlus,
      faQuestionCircle,
      faReceipt,
      faRefresh,
      faRotateLeft,
      faRuler,
      faRulerCombined,
      faScrewdriverWrench,
      faSitemap,
      faSort,
      faSortDown,
      faSortUp,
      faSquare,
      faStethoscope,
      faTimes,
      faToolbox,
      faTrash,
      faUpDownLeftRight,
      faUser,
      faUserPlus,
      faUserShield,
      faUserSlash
    );
  }
}
